import { defineSlotRecipe } from "@chakra-ui/react-v3";
import { segmentGroupAnatomy } from "@chakra-ui/react-v3/anatomy";

const $segmentRadius = "--segment-radius";
const $segmentInset = "--segment-inset";

export const segmentGroupRecipe = defineSlotRecipe({
  slots: segmentGroupAnatomy.keys(),

  base: {
    root: {
      [$segmentRadius]: "radii.md",
      [$segmentInset]: "2px",

      borderRadius: `var(${$segmentRadius})`,
      display: "inline-flex",
      minW: "max-content",
      textAlign: "center",
      position: "relative",
      isolation: "isolate",
      bg: "neutral.subtle",
      padding: `var(${$segmentInset})`,

      _vertical: {
        flexDirection: "column",
      },
    },

    item: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      gap: "2",
      position: "relative",
      color: "fg.emphasized",
      borderRadius: `var(${$segmentRadius})`,
      cursor: "pointer",

      _disabled: {
        color: "fg.muted",
        cursor: "default",
        opacity: "0.5",
      },

      "&:has(input:focus-visible)": {
        focusRing: "outside",
      },
    },

    indicator: {
      pos: "absolute",
      bg: "neutral.default",
      border: "1px solid {colors.border.container}",
      width: "var(--width)",
      height: "var(--height)",
      top: "var(--top)",
      left: "var(--left)",
      zIndex: -1,
      borderRadius: `calc(var(${$segmentRadius}) - var(${$segmentInset}))`,
    },
  },

  variants: {
    size: {
      sm: {
        item: {
          textStyle: "body.12",
          px: "2",
          height: "8", // TODO: switch to 7 when control heights are tweaked all around
        },
      },

      md: {
        root: {
          [$segmentRadius]: "radii.lg",
        },

        item: {
          textStyle: "body.14",
          px: "3",
          height: "8",
        },
      },
    },

    variant: {
      gradient: {
        item: {
          _hover: {
            color: "transparent",
            bg: "gradient.popsql",
            backgroundClip: "text",
          },

          _checked: {
            color: "transparent",
            bg: "gradient.timescale",
            backgroundClip: "text",
          },
        },
      },

      plain: {
        item: {
          _hover: {
            color: "fg.default",
          },

          _checked: {
            color: "fg.default",
          },
        },
      },
    },

    full: {
      true: {
        root: {
          width: "full",
        },

        item: {
          flex: 1,
        },
      },
    },
  },

  defaultVariants: {
    variant: "gradient",
    size: "md",
  },
});
